module.exports = __webpack_public_path__ + "media/images/dashboard/apple_app_store-065ee4a8b81983fa3731f59c3fff423f.png";